import React, { Component, useState, useEffect } from 'react';
import ImageComponent from '../../CommonComponent/CommonImage';
import { withTranslation } from 'react-i18next';
import './set-reminders.css';
import LastPeriod from '../period-calculator-landing-page/LastPeriod';
import SetReminderLastPeriod from './SetReminderLastPeriod';
import dateUtils from '../../../commonUtils/DateUtils';
import { isMobile } from 'react-device-detect';
import { postDataFetcher } from '../../../dataFetcher';
import CONFIG_OBJECT from '../../../config/config';
import App_Constants from '../../../app-constants/App_Constants';
import SetRemindersPaginator from './SetRemindersPaginator';
import PillsInjectionsData from './PillsInjectionsData';
import configData from '../../../temp/config';
import DefaultCalendar from '../DefaultCalendar/DefaultCalendar';

var now = new Date();
if (now.getMonth() == 11) {
    var current = new Date(now.getFullYear() + 1, 0, 1);
} else {
    var current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
}

let selectedTrack = {
    key: '',
    id: ''
}

let currentMonthCycle = {
    dayValue: new Date().getDate(),
    monthValue: new Date().getMonth(),
    yearValue: new Date().getFullYear(),
    cycleLength: 28,
    periodDuration: 4,
    selectedDate: '',
    reminderTime: '',
    weeeklyReminderTime: '7',
    frequencyReminderTime: '14'
}

const SetReminders = (props) => {
    const [showHeader, setShowHeader] = useState(isMobile)
    const [showTracks, setShowTracks] = useState(true);
    const [showResultSection, setShowResultSection] = useState(isMobile ? false : true);
    const [showForm, setShowForm] = useState(true);
    const [track, setTrack] = useState('');
    const [remindersData, setRemindersData] = useState({});
    const [disableBtn, setDisableBtn] = useState(true);
    const [showDefaultCalender, setShowDefaultCalender] = useState(isMobile ? false : true);
    const [resultData, setResultData] = useState({
        apiData: {},
        showCalender: false
    })
    const [isReminderSet, setIsremidnerSet] = useState(false)
    const [showEditForm, setShowEditForm] = useState(false);

    useEffect(() => {
        currentMonthCycle = {
            dayValue: new Date().getDate(),
            monthValue: new Date().getMonth(),
            yearValue: new Date().getFullYear(),
            cycleLength: 28,
            periodDuration: 4,
            selectedDate: '',
            reminderTime: '',
            weeeklyReminderTime: '7',
            frequencyReminderTime: '14'
        }
    }, [])

    // This function gets called whenever we changed anything in child component(Drop-down)
    const sendLastPeriodData = (dayValue, monthValue, yearValue, cycleLength, periodDuration, enableBtn, reminderTime, weeeklyReminderTime, frequencyReminderTime) => {
        currentMonthCycle = {
            dayValue: dayValue,
            monthValue: monthValue,
            yearValue: yearValue,
            cycleLength: cycleLength,
            periodDuration: periodDuration,
            reminderTime: reminderTime,
            weeeklyReminderTime: weeeklyReminderTime,
            frequencyReminderTime: frequencyReminderTime
        }
        console.log(currentMonthCycle)
        // console.log(currentMonthCycle.weeeklyReminderTime)
        // console.log(currentMonthCycle.frequencyReminderTime)
        if (enableBtn) {
            setDisableBtn(false)
            document.getElementById("calculate-period-button-id").disabled = false;
        } else {
            setDisableBtn(true)
            document.getElementById("calculate-period-button-id").disabled = true;
        }
        document.getElementById("calculate-period-button-id").focus()
        //setDisableBtn(false);
    }

    const mySubmitHandler = (e) => {
        e.preventDefault()
    }

    const calculatePeriod = () => {
        // if (enableBtn) {
        let month = Number(currentMonthCycle.monthValue) + 1;
        let data = {
            lastPeriodDate: `${dateUtils.formatDate(month)}-${dateUtils.formatDate(currentMonthCycle.dayValue)}-${currentMonthCycle.yearValue}`,
            periodDuration: Number(currentMonthCycle.periodDuration),
            cycleLength: `${currentMonthCycle.cycleLength}`,
        };

        let restURL = '';
        switch (remindersData.key.value) {
            case "PERIOD": {
                restURL = `${CONFIG_OBJECT.PERIOD_CALCULATOR_REST_URL}`
                break;
            }
            case "FERTILE": {
                restURL = `${CONFIG_OBJECT.GETTING_FERTILE_DAYS_REST_URL}`
                break;
            }
            case "OVULATION": {
                restURL = `${CONFIG_OBJECT.GETTING_OVULATION_DAYS_REST_URL}`
                break;
            }
        }

        if (isMobile) {
            setShowForm(false)
            setShowEditForm(true)
            // props.showEditFormForRemidners()
        }

        if (remindersData.key.value === 'PILLS' || remindersData.key.value === 'HYGIENE' || remindersData.key.value === 'INJECTION') {
            // for last 3 reminder no need to call Rest API on Proceed button click
            setResultData({ showCalender: true })
            setShowDefaultCalender(false)
            setShowResultSection(true)
            setDisableBtn(false)
            if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
        } else {
            postDataFetcher(`${restURL}${App_Constants.SC_API_KEY}&sc_lang=${localStorage.getItem('language')}`, data)
                .then(res => {
                    // console.log(res)
                    if (res.data.HasError) {
                        setResultData({
                            hasError: true
                        })

                    } else {
                        setShowDefaultCalender(false);
                        // setDisableAddBtn(true);
                        setResultData({
                            showCalender: true,
                            apiData: res.data.Data,
                            showForm: false,
                            // shoeDesc: true
                            // showWarningSection: data.periodDuration > 8
                        });
                        setShowResultSection(true)
                        // setDisableBtn(true);
                        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
                    }
                    // setShowDisabledInfo(false)
                    // setDisableAddBtn(false);
                }, err => {
                    // console.log(err);
                    setResultData({
                        hasError: true
                    })
                });
        }


        setIsremidnerSet(false)
        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = true;
    }

    const showAllReminders = () => {
        currentMonthCycle = {
            dayValue: new Date().getDate(),
            monthValue: new Date().getMonth(),
            yearValue: new Date().getFullYear(),
            cycleLength: 28,
            periodDuration: 4,
            selectedDate: '',
            reminderTime: props.componentData.timeDropDownDefaultItem,
            weeeklyReminderTime: '7',
            frequencyReminderTime: '14'
        }
        setTrack('')
        selectedTrack.key = '';
        setShowTracks(true)
        setShowResultSection(false)
        setShowForm(false)
        setShowEditForm(false)
        setShowHeader(false);
        if (isMobile) props.showSubTitle();
    }

    const setSelectedTrackData = (item) => {
        currentMonthCycle = {
            dayValue: new Date().getDate(),
            monthValue: new Date().getMonth(),
            yearValue: new Date().getFullYear(),
            cycleLength: 28,
            periodDuration: 4,
            selectedDate: '',
            reminderTime: props.componentData.timeDropDownDefaultItem,
            weeeklyReminderTime: '7',
            frequencyReminderTime: '14'
        }
        selectedTrack.key = '';
        selectedTrack.id = `{${item.id}}`;

        if (item.fields.key.value !== '' && selectedTrack.key !== item.fields.key.value) {
            selectedTrack.key = item.fields.key.value;
            setTrack(item.fields.key.value);
            setRemindersData(item.fields);
            setResultData({
                showCalender: false,
            });
            setShowDefaultCalender(true)
            setIsremidnerSet(false)
            setShowForm(true)
            if (isMobile) setShowTracks(false)
            if (isMobile) props.hideTitle();
        }

        if (isMobile) setShowHeader(true);
        // if(isMobile) {
        setTimeout(function () { window.scrollTo(0, 0); }, 0);
        // }
        // TODO : Do not delete this condiion for now

        // if ((item.fields.key.value === 'PERIOD' || item.fields.key.value === 'FERTILE' ||
        //     item.fields.key.value === 'OVULATION') && selectedTrack.key !== item.fields.key.value) {
        //     selectedTrack.key = item.fields.key.value;
        //     setTrack(item.fields.key.value);
        //     setRemindersData(item.fields);
        //     setResultData({
        //         showCalender: false,
        //     });
        //     setShowDefaultCalender(true)
        //     setIsremidnerSet(false)
        // }

        // if ((item.fields.key.value === 'PILLS' || item.fields.key.value === 'HYGIENE' ||
        //     item.fields.key.value === 'INJECTION') && selectedTrack.key !== item.fields.key.value) {
        //     selectedTrack.key = item.fields.key.value;
        //     setTrack(item.fields.key.value);
        //     setRemindersData(item.fields);
        //     setResultData({
        //         showCalender: false,
        //     });
        //     setShowDefaultCalender(true)
        //     setIsremidnerSet(false)
        // }

    }

    const hideEditedForm = () => {
        setShowForm(true)
        setShowEditForm(false)
        setTimeout(function () { window.scrollTo(0, 0); }, 0);
    }

    const setReminder = (e) => {
        e.preventDefault();
        let url = `${configData.sitecoreApiHost}/${CONFIG_OBJECT.SET_REMINDERS_REST_URL}?sc_apikey=${configData.sitecoreApiKey}`
        let EventStartDate = `${currentMonthCycle.monthValue + 1}-${currentMonthCycle.dayValue}-${currentMonthCycle.yearValue}`
        let cycleLength = currentMonthCycle.cycleLength
        let data = {
            CalendarItemId: selectedTrack.id,
            EventStartDate: EventStartDate + ' ' + currentMonthCycle.reminderTime.fields.key.value,
            Interval: cycleLength,
            NoOfRecurrences: props.NoofRecurrences != null ? props.NoofRecurrences.value : 5,
            ReminderKey: remindersData.key.value
        }
        if (remindersData.key.value === 'PILLS') {
            data.Interval = remindersData.frequencyDropDownDefaultValue.fields.key.value || '0';
            data.NoOfRecurrences = currentMonthCycle.weeeklyReminderTime
        }

        if (remindersData.key.value === 'HYGIENE') {
            data.Interval = currentMonthCycle.frequencyReminderTime || '0';
            data.NoOfRecurrences = remindersData.durationDropDownDefaultValue.fields.key.value || '0'
        }

        if (remindersData.key.value === 'INJECTION') {
            data.Interval = remindersData.frequencyDropDownDefaultValue.fields.key.value || '0';
            data.NoOfRecurrences = remindersData.durationDropDownDefaultValue.fields.key.value || '0'
        }


        // if (remindersData.key.value === 'PILLS' || remindersData.key.value === 'HYGIENE' || remindersData.key.value === 'INJECTION') {
        postDataFetcher(url, data)
            .then(res => {
                if (res.data.HasError) {
                    console.log('Haserror: ', res.data)
                } else {
                    console.log('success')
                    document.calendarform.action = `${url}` + '&CalendarItemId=' + data.CalendarItemId + '&EventStartDate=' + data.EventStartDate + '&Interval=' + data.Interval + '&NoofRecurrences=' + data.NoOfRecurrences + '&ReminderKey=' + `${data.ReminderKey}`
                    document.calendarform.submit();
                    setResultData({
                        showCalender: false,
                    })
                    setIsremidnerSet(true)
                    if (isMobile) {
                        setTimeout(function () { window.scrollTo(0, 0); }, 0);
                    }
                }
            }, err => {
                console.log('Error: ', err)
            });

    }

    const setAnotherPillsReminder = () => {
        setShowDefaultCalender(true);
        setResultData({ showCalender: false })
        setDisableBtn(false)
        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = false;
    }

    const setAnotherTrackingDaysReminder = () => {
        // currentMonthCycle = {
        //     dayValue: new Date().getDate(),
        //     monthValue: new Date().getMonth(),
        //     yearValue: new Date().getFullYear(),
        //     cycleLength: 28,
        //     periodDuration: 4,
        //     selectedDate: '',
        //     reminderTime: '11:00:00',
        //     weeeklyReminderTime: '7',
        //     frequencyReminderTime: '1'
        // }
        // setTrack(remindersData);
        setShowDefaultCalender(true);
        setResultData({ showCalender: false })
        setIsremidnerSet(false)
        setDisableBtn(false)
        if (document.getElementById("calculate-period-button-id")) document.getElementById("calculate-period-button-id").disabled = false;
    }

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const { t } = props;
    let addReminderText = t('PeriodCalculator_AddAnotherReminder');
    const addReminderMobText = {
        __html: addReminderText
    }

    return (

        <>
            {showTracks ? <div className="set-reminders-header">
                <p>{props.componentData.remindersTitle.value} </p>
                <div className="set-reminders">
                    {/*  */}
                    {props.componentData.reminders.map((item, index) => {
                        return (
                            <>
                                <div className={`${item.fields.key.value === track ? 'active' : ''}`} key={`${item.fields.key.value}${index}`} onClick={() => setSelectedTrackData(item)}>
                                    <span className="set-reminders-features" >{item.fields.title.value}</span>
                                </div>
                            </>

                        )
                    })}
                </div>
            </div> :
                <div className="view-all-reminder-parent">
                    <div className="choose-all-reminders" onClick={showAllReminders}>

                        {isMobile && <img className="back-arrow" src={`${configData.sitecoreApiHost}${props.parentCompData.leftArrowActiveLogo.value.src}`} alt="" />}
                        <img className="menu-logo" src={`${configData.sitecoreApiHost}${props.componentData.viewAllReminderLogo.value.src}`} alt="" />
                        <span dangerouslySetInnerHTML={addReminderMobText}></span>
                        {/* {isMobile && <ImageComponent imageIcon={props.parentCompData.menuLogo.value.src} />}  */}
                    </div>
                </div>}


            {remindersData.key && (remindersData.key.value === 'PERIOD' || remindersData.key.value === 'FERTILE' ||
                remindersData.key.value === 'OVULATION') && showEditForm && <>
                    <div className="recalculate-wrap-period-form">

                        <div className="fdlp-mobile">
                            <img src={`${configData.sitecoreApiHost}${props.parentCompData.datePickerLogo.value.src}`} />
                            <span>{remindersData.dateSelectionLabel.value}</span><span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
                        </div>
                        <div className="avg-period-mobile"><span>{remindersData.durationSelection1Label.value}</span><span>{currentMonthCycle.periodDuration} {props.t('PeriodCalculator_DaysLabel')}</span></div>
                        <div className="cycle-length-mobile"><span>{remindersData.durationSelection2Label.value}</span><span>{currentMonthCycle.cycleLength} {props.t('PeriodCalculator_DaysLabel')}</span></div>
                        <div className="cycle-length-mobile ltr-common"><span>{remindersData.timeSelectionLabel.value}</span>
                            <span>{(currentMonthCycle.reminderTime.name && currentMonthCycle.reminderTime.name.value) || currentMonthCycle.reminderTime.fields.name.value}</span>
                        </div>
                        <button onClick={hideEditedForm}>
                            <img src={`${configData.sitecoreApiHost}${props.parentCompData.editLogo.value.src}`} />
                        </button>
                    </div>
                </>}
            {showHeader && <div className="goal-header">
                <h1 className="sub-heading"> {remindersData.title && remindersData.title.value}</h1>
                {/* {!isMobile && <p className="ovulation-intro">{goalData.goalData.fields && goalData.goalData.fields.description.value}</p>} */}
            </div>}
            {/* First 3 sub scenarios */}
            {remindersData.key && (remindersData.key.value === 'PERIOD' || remindersData.key.value === 'FERTILE' ||
                remindersData.key.value === 'OVULATION') && <div className="form-container set-reminders-form" onSubmit={mySubmitHandler}>
                    {showForm && <form role="form" className="form-inline">
                        <div className="toolform">
                            <SetReminderLastPeriod sendLastPeriodData={sendLastPeriodData}
                                goalData={props.componentData}
                                componentData={remindersData}
                                parentCompData={props.parentCompData}
                                currentMonthCycle={currentMonthCycle}
                                selectedTrack={remindersData.key.value} />
                            <div className="submitBtnWrapper">
                                <button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
                                    {remindersData.submitLabel.value}
                                    <span></span>
                                    {/* <ImageComponent imageIcon={props.parentCompData.forwardRightArrowLogo.value.src} /> */}
                                </button>
                            </div>


                        </div>
                    </form>}

                    {showResultSection && <div className="result-section">
                        <div className="calendar">
                            {showDefaultCalender &&
                                <div className="default-calendar">
                                    <DefaultCalendar date={now} />
                                    <DefaultCalendar date={current} />
                                </div>
                                // <img src="https://dev1.v2.wemshowcase.com/-/media/JssReactWeb/data/media/img/PeriodCalculator/defaultCalendar.ashx" alt="" />

                            }
                            {resultData.showCalender &&
                                <SetRemindersPaginator result={resultData.apiData} sendLastPeriodData={sendLastPeriodData}
                                    // componentData={componentData}
                                    selectedTrack={remindersData.key.value}
                                    parentCompData={props.parentCompData}
                                    currentMonthCycle={currentMonthCycle}
                                />
                            }
                            {isReminderSet && <div className="reminder-set">
                                <ImageComponent imageIcon={props.componentData.successReminderLogo.value.src} />
                                <div className="reminder-success">
                                    <h5 className="reminder-success-msg">{props.componentData.successMessage.value}</h5>
                                    {/* <h5 className="set-another-reminder" onClick={setAnotherTrackingDaysReminder}>{props.componentData.anotherReminderMessage.value}</h5> */}
                                </div>

                            </div>}
                        </div>
                        {resultData.showCalender && <div className="set-reminders-button">
                            <form method="post" name="calendarform" id="calendarform">

                                <button onClick={setReminder}>
                                    <img className="menu-logo" src={`${configData.sitecoreApiHost}${remindersData.addToCalendarLogo.value.src}`} alt="" />
                                    {remindersData.addToCalendarTitle.value}
                                </button>
                            </form>
                        </div>}
                    </div>}
                </div>}
            {remindersData.key && (remindersData.key.value === 'PILLS' || remindersData.key.value === 'HYGIENE' ||
                remindersData.key.value === 'INJECTION') && showEditForm && <>
                    <div className="recalculate-wrap-period-form">
                        <div className="fdlp-mobile">
                            <img src={`${configData.sitecoreApiHost}${props.parentCompData.datePickerLogo.value.src}`} />
                            <span>{remindersData.startDateSelectionLabel.value}</span><span>{currentMonthCycle.dayValue} {months[currentMonthCycle.monthValue]}, {currentMonthCycle.yearValue}</span>
                        </div>
                        <div className="avg-period-mobile ltr-common"><span>{remindersData.timeSelectionLabel.value}</span>
                            <span>{(currentMonthCycle.reminderTime.name && currentMonthCycle.reminderTime.name.value) || currentMonthCycle.reminderTime.fields.name.value} </span>
                        </div>

                        {selectedTrack.key === 'PILLS' && <div className="cycle-length-mobile">
                            <span>{remindersData.durationSelectionLabel.value}</span><span>{currentMonthCycle.weeeklyReminderTime} {props.t('PeriodCalculator_DaysLabel')}</span>
                        </div>}
                        {selectedTrack.key === 'HYGIENE' && <div className="cycle-length-mobile">
                            <span>{remindersData.frequencySelectionLabel.value}</span><span>{currentMonthCycle.frequencyReminderTime} {props.t('PeriodCalculator_DaysLabel')}</span>
                        </div>}
                        <button onClick={hideEditedForm}>
                            <img src={`${configData.sitecoreApiHost}${props.parentCompData.editLogo.value.src}`} />
                        </button>
                    </div>
                </>}
            {/* Last 3 sub scenarios */}
            {remindersData.key && (remindersData.key.value === 'PILLS' || remindersData.key.value === 'HYGIENE' ||
                remindersData.key.value === 'INJECTION') && <div className="form-container set-reminders-form" onSubmit={mySubmitHandler} id="injection-form">

                    {showForm && <form role="form" className="form-inline">
                        <div className="toolform">
                            <PillsInjectionsData sendLastPeriodData={sendLastPeriodData}
                                goalData={props.componentData}
                                componentData={remindersData}
                                parentCompData={props.parentCompData}
                                currentMonthCycle={currentMonthCycle}
                                selectedTrack={remindersData.key.value} />
                            <div class="submitBtnWrapper">
                                <button type="submit" id="calculate-period-button-id" className="btn red calculate-button" onClick={calculatePeriod} disabled={disableBtn}>
                                    {remindersData.submitLabel.value}
                                </button>
                            </div>

                        </div>
                    </form>}

                    {showResultSection && <div className="result-section pills-result-section">
                        {showDefaultCalender && <div className="blank-div">
                        </div>
                        }
                        {!showDefaultCalender && <div className="calendar">
                            {!isReminderSet && <div>
                                <ImageComponent imageIcon={remindersData.reminderReadyImage.value.src} />
                                <h2 className="reminder-ready-message">{remindersData.reminderReadyMessage.value} </h2>
                                <p className="reminder-sub-ready-message">{remindersData.reminderReadySubMessage.value}</p>
                            </div>}
                            {isReminderSet && <div className="reminder-set">
                                <ImageComponent imageIcon={props.componentData.successReminderLogo.value.src} />
                                <div className="reminder-success">
                                    <h5 className="reminder-success-msg">{props.componentData.successMessage.value}</h5>
                                    {/* <h5 className="set-another-reminder" onClick={setAnotherPillsReminder}>{props.componentData.anotherReminderMessage.value}</h5> */}
                                </div>
                            </div>}
                        </div>}
                        {resultData.showCalender && <div className="set-reminders-button">
                            <form method="post" name="calendarform" id="calendarform">
                                <button onClick={setReminder}>
                                    <img className="menu-logo" src={`${configData.sitecoreApiHost}${remindersData.addToCalendarLogo.value.src}`} alt="" />
                                    {remindersData.addToCalendarTitle.value}
                                </button>
                            </form>
                        </div>}
                    </div>}

                </div>}

        </>
    )
}


export default withTranslation()(SetReminders)

